import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useCurrentFormulation } from '@/hooks/useCurrentFormulation';
import { exportIdentifier } from '@/utils/export/identifier';

export function PrintFlaskPage() {
  const { flavorId, formulaId } = useParams<{ flavorId: string; formulaId: string }>();
  const fid = formulaId ? Number(formulaId) : NaN;
  const q = useCurrentFormulation(flavorId ?? '', Number.isFinite(fid) ? fid : 0);

  // Auto-open the print dialog once data is in the DOM.
  useEffect(() => {
    if (q.data) {
      const t = setTimeout(() => window.print(), 250);
      return () => clearTimeout(t);
    }
  }, [q.data]);

  if (!flavorId || !Number.isFinite(fid)) {
    return <div style={{ padding: 16 }}>Invalid URL.</div>;
  }
  if (q.isLoading) return <div style={{ padding: 16 }}>Loading…</div>;
  if (q.isError)   return <div style={{ padding: 16 }}>Failed to load.</div>;
  if (!q.data)     return null;

  const data = q.data;
  return (
    <div style={{ padding: 16, color: 'black' }}>
      <header className="print-no-print" style={{ marginBottom: 12 }}>
        <button type="button" onClick={() => window.print()}>Print</button>
      </header>
      <div style={{ marginBottom: 8, fontSize: 12 }}>
        <strong>Flavor:</strong> {flavorId} · <strong>Formula:</strong> {fid} ·{' '}
        <strong>Generated:</strong> {new Date().toLocaleString()} ·{' '}
        <strong>Items:</strong> {data.itemCount}
      </div>
      <table className="print-flask">
        <thead>
          <tr>
            <th>Substance Name</th>
            <th>Identifier</th>
            <th className="right">Amount</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((r, i) => (
            <tr key={i}>
              <td>{r.substanceName}</td>
              <td>{exportIdentifier(r)}</td>
              <td className="right">{r.amountValue ?? ''}</td>
              <td>{r.amountUnit ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
